import { styled } from '@/styled-system/jsx';

export const CardContainer = styled('div', {
  base: {
    borderRadius: '4px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey100',
  },
});
